interface BurnPriceSample {
  price: number
  priceInPoints: number
  loyaltyProductType: App.LoyaltyProductType
}

export function getCashPriceCap(
  pointsBalance: number | undefined,
  samples: Array<BurnPriceSample>,
): number | undefined {
  if (pointsBalance === undefined) return undefined

  const validSamples = samples.filter(sample => sample.priceInPoints > 0)

  // Use the highest-priced offer for each product type to minimise rounding
  // effects, then retain the most permissive regional cash-per-point rate.
  const samplesByProductType = new Map<App.LoyaltyProductType, BurnPriceSample>()
  for (const sample of validSamples) {
    const existing = samplesByProductType.get(sample.loyaltyProductType)
    if (!existing || sample.price > existing.price) {
      samplesByProductType.set(sample.loyaltyProductType, sample)
    }
  }

  const cashPerPoint = Math.max(...[...samplesByProductType.values()].map(sample => (
    sample.price / sample.priceInPoints
  )))

  return Number.isFinite(cashPerPoint) ? Math.ceil(pointsBalance * cashPerPoint) : undefined
}
